import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";

function ArrowIcon(props:SvgProps) {
  return (
    <Svg
      width={50}
      height={12}
      viewBox="0 0 50 12"
      fill="none"
      {...props} 
    >
      <Path
        d="M1 5.25a.75.75 0 000 1.5v-1.5zm48.53 1.28a.75.75 0 000-1.06L44.757.697a.75.75 0 00-1.06 1.06L47.939 6l-4.242 4.243a.75.75 0 001.06 1.06L49.53 6.53zM1 6v.75h48v-1.5H1V6z"
        fill={props.fill || "#80868C"}
      />
    </Svg>
  );
}

export default ArrowIcon;